import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center gap-4 align-middle min-w-20" }
const _hoisted_2 = { class: "w-[520px] max-w-[90vw] p-0 bg-white dark:bg-gray-900 rounded-lg shadow-lg overflow-hidden" }
const _hoisted_3 = { class: "grid grid-cols-3 divide-x divide-gray-200 dark:divide-gray-700" }
const _hoisted_4 = { class: "p-4 bg-pink-50 dark:bg-pink-950/20" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "inline-flex items-center gap-2 px-3 py-1 bg-pink-200 dark:bg-pink-800 text-pink-800 dark:text-pink-200 rounded-full text-xs font-medium" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "min-w-0 flex-1" }
const _hoisted_9 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm leading-tight" }
const _hoisted_10 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_11 = { class: "p-4 bg-blue-50 dark:bg-blue-950/20" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "inline-flex items-center gap-2 px-3 py-1 bg-blue-200 dark:bg-blue-800 text-blue-800 dark:text-blue-200 rounded-full text-xs font-medium" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = { class: "min-w-0 flex-1" }
const _hoisted_16 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm leading-tight" }
const _hoisted_17 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_18 = { class: "p-4 bg-purple-50 dark:bg-purple-950/20" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "inline-flex items-center gap-2 px-3 py-1 bg-purple-200 dark:bg-purple-800 text-purple-800 dark:text-purple-200 rounded-full text-xs font-medium" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = { class: "min-w-0 flex-1" }
const _hoisted_23 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm leading-tight" }
const _hoisted_24 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_25 = { class: "flex flex-col h-full w-full md:m-8" }
const _hoisted_26 = { class: "flex items-center justify-between p-4" }
const _hoisted_27 = { class: "flex-1 px-4 py-4 space-y-3 overflow-y-auto" }
const _hoisted_28 = { class: "font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_29 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_30 = { class: "flex items-center gap-3 w-full p-3 rounded-xl bg-white dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700" }
const _hoisted_31 = { class: "font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_32 = { class: "ml-3 space-y-1.5" }
const _hoisted_33 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm" }
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5"
}
const _hoisted_35 = { class: "space-y-3" }
const _hoisted_36 = { class: "p-3 bg-gradient-to-br from-pink-50 to-rose-50 dark:from-pink-950/20 dark:to-rose-950/20 rounded-xl border border-pink-200 dark:border-pink-800/40" }
const _hoisted_37 = { class: "mb-2" }
const _hoisted_38 = { class: "inline-flex items-center gap-1.5 px-2.5 py-1 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-md text-xs font-bold" }
const _hoisted_39 = { class: "space-y-1.5" }
const _hoisted_40 = { class: "p-1.5 bg-gradient-to-br from-pink-500 to-rose-500 rounded-md" }
const _hoisted_41 = { class: "flex-1" }
const _hoisted_42 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm" }
const _hoisted_43 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_44 = { class: "p-3 bg-gradient-to-br from-blue-50 to-sky-50 dark:from-blue-950/20 dark:to-sky-950/20 rounded-xl border border-blue-200 dark:border-blue-800/40" }
const _hoisted_45 = { class: "mb-2" }
const _hoisted_46 = { class: "inline-flex items-center gap-1.5 px-2.5 py-1 bg-gradient-to-r from-blue-500 to-sky-500 text-white rounded-md text-xs font-bold" }
const _hoisted_47 = { class: "space-y-1.5" }
const _hoisted_48 = { class: "p-1.5 bg-gradient-to-br from-blue-500 to-sky-500 rounded-md" }
const _hoisted_49 = { class: "flex-1" }
const _hoisted_50 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm" }
const _hoisted_51 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_52 = { class: "p-3 bg-gradient-to-br from-purple-50 to-violet-50 dark:from-purple-950/20 dark:to-violet-950/20 rounded-xl border border-purple-200 dark:border-purple-800/40" }
const _hoisted_53 = { class: "mb-2" }
const _hoisted_54 = { class: "inline-flex items-center gap-1.5 px-2.5 py-1 bg-gradient-to-r from-purple-500 to-violet-500 text-white rounded-md text-xs font-bold" }
const _hoisted_55 = { class: "space-y-1.5" }
const _hoisted_56 = { class: "p-1.5 bg-gradient-to-br from-purple-500 to-violet-500 rounded-md" }
const _hoisted_57 = { class: "flex-1" }
const _hoisted_58 = { class: "font-medium text-gray-900 dark:text-gray-100 text-sm" }
const _hoisted_59 = { class: "text-xs text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_60 = { class: "border-t border-gray-200 dark:border-gray-700 bg-gradient-to-r from-white to-gray-50 dark:from-gray-900 dark:to-gray-800 p-4 space-y-3" }
const _hoisted_61 = { class: "flex items-center justify-center" }

import type { NavigationMenuItem } from "#ui/types";

interface ExtendedNavigationMenuItem extends NavigationMenuItem {
  group?: string;
  icon?: string;
  children?: ExtendedNavigationMenuItem[];
}

// Use the store's reactive isConnected state directly
// Initialize authentication check for SSR

export default /*@__PURE__*/_defineComponent({
  __name: 'topHeader',
  async setup(__props) {

let __temp: any, __restore: any

const auth = useAuthStore();
const config = useRuntimeConfig();

// Extend NavigationMenuItem to include group property
;(
  ([__temp,__restore] = _withAsyncContext(() => auth.isAuthenticated())),
  await __temp,
  __restore()
);
// const emit = defineEmits(["sidebar:isOpen", "main:isModalOpen"]);

const links = [
  {
    label: "Tools",
    defaultOpen: true,
    children: [
      {
        label: "Genogram",
        to: "/tools/genogram",
        icon: "i-hugeicons:workflow-square-10",
        description: "Create beautiful Genogram easily.",
      },
    ],
  },
  {
    label: "Discover",
    slot: "discover" as const,
    defaultOpen: true,
    children: [
      {
        label: "Family Engagement",
        to: "/more/family-engagement",
        icon: "i-heroicons-heart",
        description: "Life story work",
        group: "follow",
      },
      {
        label: "Resident Profiles",
        to: "/more/resident-profiles",
        icon: "i-heroicons-user-circle",
        description: "Track resident journey",
        group: "follow",
      },
      {
        label: "Direct Work",
        to: "/more/direct-work",
        icon: "i-heroicons-clipboard-document-list",
        description: "Track work sessions",
        group: "track",
      },
      {
        label: "Progress & Observations",
        to: "/more/progress-observations",
        icon: "i-heroicons-chart-bar",
        description: "Log and monitor",
        group: "track",
      },
      {
        label: "Tasks & Collaboration",
        to: "/more/team-collaboration",
        icon: "i-heroicons-user-group",
        description: "Assign and share",
        group: "centralise",
      },
      {
        label: "Centralised Dashboard",
        to: "/more/centralised-dashboard",
        icon: "i-heroicons-squares-2x2",
        description: "Manage all operations",
        group: "centralise",
      },
    ],
  },
  {
    label: "Pricing",
    to: "/pricing",
  },
  {
    label: "Blog",
    to: "/blog",
  },
  {
    label: "About",
    to: "/about",
  },
  {
    label: "Contact",
    to: "/contact-sale",
  },
] satisfies ExtendedNavigationMenuItem[];

const userLinks = [
  {
    label: "Dashboard",
    icon: "i-heroicons-book-open",
    onSelect: () => navigateTo("/user/", { external: true }),
  },
  {
    label: "Tools",
    defaultOpen: true,
    children: [
      {
        label: "Genogram",
        to: "/tools/genogram",
        icon: "i-hugeicons:workflow-square-10",
        description: "Create beautiful Genogram easily.",
      },
    ],
  },
  // {
  //     label: "Settings",
  //     icon: "i-heroicons-cog-6-tooth",
  //     to: "/settings"
  // },
  {
    label: "Blog",
    icon: "i-heroicons-newspaper",
    to: "/blog",
  },
] satisfies ExtendedNavigationMenuItem[];

const menuLinks = computed(() => (auth.isConnected ? userLinks : links));

// Group the discover children by categories
const discoverGroups = computed(() => {
  const discoverItem = links.find((link) => link.label === "Discover");
  if (!discoverItem?.children) return [];

  const groups = {
    follow: {
      title: "Follow",
      subtitle: "Family Journey",
      icon: "i-heroicons-heart",
      children: [] as ExtendedNavigationMenuItem[],
    },
    track: {
      title: "Track",
      subtitle: "Progress & Work",
      icon: "i-heroicons-chart-bar",
      children: [] as ExtendedNavigationMenuItem[],
    },
    centralise: {
      title: "Centralise",
      subtitle: "Operations",
      icon: "i-heroicons-squares-2x2",
      children: [] as ExtendedNavigationMenuItem[],
    },
  };

  discoverItem.children.forEach((child: ExtendedNavigationMenuItem) => {
    if (child.group && groups[child.group as keyof typeof groups]) {
      groups[child.group as keyof typeof groups].children.push(child);
    }
  });

  return Object.values(groups) as unknown as ExtendedNavigationMenuItem[];
});

const scrolled = ref(false);
const isAnimating = ref(false);

const triggerPulse = () => {
  if (!isAnimating.value) {
    isAnimating.value = true;
    setTimeout(() => {
      isAnimating.value = false;
    }, 1700);
  }
};

onMounted(() => {
  let ticking = false;

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        scrolled.value = window.scrollY > 10;
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
});

const logout = async () => {
  await auth.logout();
};

return (_ctx: any,_cache: any) => {
  const _component_UColorModeImage = _resolveComponent("UColorModeImage")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_ULink = _resolveComponent("ULink")!
  const _component_UNavigationMenu = _resolveComponent("UNavigationMenu")!
  const _component_NuxtImg = _resolveComponent("NuxtImg")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UColorModeButton = _resolveComponent("UColorModeButton")!
  const _component_UHeader = _resolveComponent("UHeader")!

  return (_openBlock(), _createBlock(_component_UHeader, {
    class: "w-full mx-auto fixed top-2 left-0 sm:mt-0 px-4 sm:px-6 lg:px-8 border-none bg-transparent blur-none backdrop-blur-none",
    toggle: {
      color: 'primary',
      variant: 'subtle',
      class: 'rounded-full',
    },
    mode: "modal",
    ui: {
      body: 'p-6 sm:p-6 overflow-y-auto w-full mx-auto md:fixed md:top-2 md:left-0 sm:mt-0 px-4 sm:px-6 lg:px-2 flex justify-center border-none bg-transparent',
      container: `mt-5 flex justify-between items-center h-16 ring-1 ring-inset dark:ring-gray-700 ring-gray-200 rounded-full px-8  bg-background/95 backdrop-blur-sm sm:bg-background/70 sm:backdrop-blur-lg gap-10 transition-all duration-500 ${_unref(scrolled) ? 'mt-0 w-[80vw] max-w-4xl ' : 'mt-10 sm:mt-10 w-[90vw] max-w-5xl '}`,
      left: 'lg:flex-1 flex items-center gap-1.5 ',
      center: 'items-center justify-end lg:flex-1 gap-1.5 hidden md:flex lg:flex',
      right: 'flex items-center justify-end lg:flex-1 gap-1.5 md:flex lg:flex',
      title: 'shrink-0 font-bold text-xl text-gray-900 dark:text-white flex items-end gap-1.5 pr-2',
    }
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["cursor-pointer transition-all duration-300 rounded-lg", { 'animate-heartbeat': _unref(isAnimating) }]),
          onMouseenter: triggerPulse
        }, [
          _createVNode(_component_UColorModeImage, {
            id: "hometop",
            light: "/images/logo_light.svg",
            dark: "/images/logo_dark.svg",
            alt: "FamilyAxis logo",
            class: "h-7"
          })
        ], 34),
        _createVNode(_component_UColorModeImage, {
          light: "./images/familyaxis.svg",
          dark: "./images/familyaxis_dark.svg",
          alt: "FamilyAxis",
          class: "h-6"
        })
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_NuxtLink, {
            to: "/",
            class: "flex items-center gap-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["p-2 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg shadow-md transition-all duration-300 cursor-pointer", { 'animate-heartbeat': _unref(isAnimating) }]),
                onMouseenter: triggerPulse
              }, [
                _createVNode(_component_NuxtImg, {
                  src: "/logo.svg",
                  alt: "Logo",
                  class: "h-5 w-5 filter brightness-0 invert"
                })
              ], 34),
              _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "font-bold text-lg text-gray-900 dark:text-white" }, [
                  _createTextVNode(" Family"),
                  _createElementVNode("span", { class: "text-blue-600 dark:text-blue-400" }, "Axis")
                ]),
                _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Navigation")
              ], -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuLinks), (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.label
            }, [
              (item.label !== 'Discover')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!item.children && item.to)
                      ? (_openBlock(), _createBlock(_component_ULink, {
                          key: 0,
                          to: item.to,
                          class: "flex items-center gap-3 w-full p-3 rounded-xl bg-white dark:bg-gray-800 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-200 shadow-sm border border-gray-200 dark:border-gray-700"
                        }, {
                          default: _withCtx(() => [
                            (item.icon)
                              ? (_openBlock(), _createBlock(_component_UIcon, {
                                  key: 0,
                                  name: item.icon,
                                  class: "h-5 w-5 text-blue-600 dark:text-blue-400"
                                }, null, 8, ["name"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (item.children)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              (item.icon)
                                ? (_openBlock(), _createBlock(_component_UIcon, {
                                    key: 0,
                                    name: item.icon,
                                    class: "h-5 w-5 text-blue-600 dark:text-blue-400"
                                  }, null, 8, ["name"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(item.label), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: child.label
                                }, [
                                  (child && child.to)
                                    ? (_openBlock(), _createBlock(_component_ULink, {
                                        key: 0,
                                        to: child.to,
                                        class: "flex items-start gap-2.5 w-full p-2.5 rounded-lg bg-gray-50 dark:bg-gray-800/50 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-all duration-200"
                                      }, {
                                        default: _withCtx(() => [
                                          (child.icon)
                                            ? (_openBlock(), _createBlock(_component_UIcon, {
                                                key: 0,
                                                name: child.icon,
                                                class: "h-4 w-4 text-gray-600 dark:text-gray-400 mt-0.5"
                                              }, null, 8, ["name"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(child.label), 1),
                                            (child.description)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(child.description), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createElementVNode("div", _hoisted_35, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
              _createElementVNode("div", { class: "h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent flex-1" }),
              _createElementVNode("span", { class: "text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide" }, "Discover"),
              _createElementVNode("div", { class: "h-px bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-600 to-transparent flex-1" })
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_UIcon, {
                    name: "i-heroicons-heart",
                    class: "h-3 w-3"
                  }),
                  _cache[9] || (_cache[9] = _createTextVNode(" Follow ", -1))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-pink-700 dark:text-pink-300 mt-1.5 font-medium" }, " Family Journey ", -1))
              ]),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[0]?.children, (child) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: child.label
                  }, [
                    (child && child.to)
                      ? (_openBlock(), _createBlock(_component_ULink, {
                          key: 0,
                          to: child.to,
                          class: "flex items-start gap-2.5 w-full p-2.5 rounded-lg bg-white/60 dark:bg-pink-900/10 hover:bg-pink-100/60 dark:hover:bg-pink-900/20 transition-all duration-200 border border-pink-200/50 dark:border-pink-800/30"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_UIcon, {
                                name: child.icon,
                                class: "h-3.5 w-3.5 text-white"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, _toDisplayString(child.label), 1),
                              _createElementVNode("div", _hoisted_43, _toDisplayString(child.description), 1)
                            ]),
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-chevron-right",
                              class: "h-3.5 w-3.5 text-pink-400 dark:text-pink-500 mt-1"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_UIcon, {
                    name: "i-heroicons-chart-bar",
                    class: "h-3 w-3"
                  }),
                  _cache[11] || (_cache[11] = _createTextVNode(" Track ", -1))
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-blue-700 dark:text-blue-300 mt-1.5 font-medium" }, " Progress & Work ", -1))
              ]),
              _createElementVNode("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[1]?.children, (child) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: child.label
                  }, [
                    (child && child.to)
                      ? (_openBlock(), _createBlock(_component_ULink, {
                          key: 0,
                          to: child.to,
                          class: "flex items-start gap-2.5 w-full p-2.5 rounded-lg bg-white/60 dark:bg-blue-900/10 hover:bg-blue-100/60 dark:hover:bg-blue-900/20 transition-all duration-200 border border-blue-200/50 dark:border-blue-800/30"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_UIcon, {
                                name: child.icon,
                                class: "h-3.5 w-3.5 text-white"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, _toDisplayString(child.label), 1),
                              _createElementVNode("div", _hoisted_51, _toDisplayString(child.description), 1)
                            ]),
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-chevron-right",
                              class: "h-3.5 w-3.5 text-blue-400 dark:text-blue-500 mt-1"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_UIcon, {
                    name: "i-heroicons-squares-2x2",
                    class: "h-3 w-3"
                  }),
                  _cache[13] || (_cache[13] = _createTextVNode(" Centralise ", -1))
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-purple-700 dark:text-purple-300 mt-1.5 font-medium" }, " Operations ", -1))
              ]),
              _createElementVNode("div", _hoisted_55, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[2]?.children, (child) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: child.label
                  }, [
                    (child && child.to)
                      ? (_openBlock(), _createBlock(_component_ULink, {
                          key: 0,
                          to: child.to,
                          class: "flex items-start gap-2.5 w-full p-2.5 rounded-lg bg-white/60 dark:bg-purple-900/10 hover:bg-purple-100/60 dark:hover:bg-purple-900/20 transition-all duration-200 border border-purple-200/50 dark:border-purple-800/30"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_UIcon, {
                                name: child.icon,
                                class: "h-3.5 w-3.5 text-white"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, _toDisplayString(child.label), 1),
                              _createElementVNode("div", _hoisted_59, _toDisplayString(child.description), 1)
                            ]),
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-chevron-right",
                              class: "h-3.5 w-3.5 text-purple-400 dark:text-purple-500 mt-1"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          (!_unref(auth).isConnected)
            ? (_openBlock(), _createBlock(_component_UButton, {
                key: 0,
                to: _unref(config).public.prelaunch ? '#' : '/login',
                label: "Log in",
                trailing: "",
                size: "md",
                variant: "solid",
                class: "w-full rounded-md justify-center font-medium shadow-md hover:shadow-lg transition-all duration-300 bg-primary-600! hover:bg-primary-700!"
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_unref(auth).isConnected)
            ? (_openBlock(), _createBlock(_component_UButton, {
                key: 1,
                label: "Log out",
                size: "md",
                variant: "outline",
                class: "w-full rounded-xl justify-center font-medium transition-all duration-300",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(auth).logout()))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_UColorModeButton, {
              size: "md",
              variant: "ghost",
              class: "rounded-lg transition-all duration-300"
            })
          ])
        ])
      ])
    ]),
    right: _withCtx(() => [
      (!_unref(auth).isConnected)
        ? (_openBlock(), _createBlock(_component_UButton, {
            key: 0,
            to: _unref(config).public.prelaunch ? '#' : '/login',
            label: "Log in",
            trailing: "",
            size: "md",
            variant: "solid",
            class: "rounded-md hidden lg:flex bg-primary-600! hover:bg-primary-700!"
          }, null, 8, ["to"]))
        : _createCommentVNode("", true),
      (_unref(auth).isConnected)
        ? (_openBlock(), _createBlock(_component_UButton, {
            key: 1,
            label: "Log out",
            class: "mx-2 rounded-full hidden lg:flex",
            size: "md",
            variant: "solid",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_UColorModeButton, { class: "hidden lg:flex" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_UNavigationMenu, {
        class: "hidden md:flex lg:flex flex-1",
        ui: {
        viewport: 'sm:w-full flex flex-1',
        content:
          'data-[motion=from-start]:animate-[enter-from-left_200ms_ease] data-[motion=from-end]:animate-[enter-from-right_200ms_ease] data-[motion=to-start]:animate-[exit-to-left_200ms_ease] data-[motion=to-end]:animate-[exit-to-right_200ms_ease]',

        viewportWrapper: 'justify-start w-[520px]',
        body: 'p-6 sm:p-6 overflow-y-auto w-full mx-auto md:fixed md:top-2 md:left-0 sm:mt-0 px-4 sm:px-6 lg:px-2 flex justify-center border-none bg-transparent',
        // childList: 'sm:w-96',
        // childLinkDescription: 'text-balance line-clamp-2'
        // viewport: 'sm:w-(--reka-navigation-menu-viewport-width * 2) sm:max-w-[100vw] overflow-visible',
        // viewport: 'relative overflow-visible bg-default shadow-lg rounded-md ring ring-default h-(--reka-navigation-menu-viewport-height) w-full transition-[width,height,left] duration-200 origin-[top_center] data-[state=open]:animate-[scale-in_100ms_ease-out] data-[state=closed]:animate-[scale-out_100ms_ease-in] z-[1]',
        // content: 'sm:w-(--reka-navigation-menu-viewport-width * 2) sm:max-w-[100vw] overflow-visible',
        // childList: 'sm:w-(--reka-navigation-menu-viewport-width * 2) sm:max-w-[100vw] overflow-visible',
        // childLinkDescription: 'text-balance line-clamp-2'
      },
        orientation: "horizontal",
        "content-orientation": "horizontal",
        items: _unref(menuLinks)
      }, {
        "discover-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_UIcon, {
                      name: "i-heroicons-heart",
                      class: "h-3 w-3"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode(" Follow ", -1))
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs text-pink-700 dark:text-pink-300 mt-1 font-medium" }, " Family Journey ", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[0]?.children, (child) => {
                    return (_openBlock(), _createBlock(_component_ULink, {
                      key: child.label,
                      to: child.to,
                      class: "flex items-start gap-3 p-2 rounded-md hover:bg-pink-100 dark:hover:bg-pink-900/30 transition-colors group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UIcon, {
                          name: child.icon,
                          class: "h-4 w-4 text-pink-600 dark:text-pink-400 mt-0.5 shrink-0"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(child.label), 1),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(child.description), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_UIcon, {
                      name: "i-heroicons-chart-bar",
                      class: "h-3 w-3"
                    }),
                    _cache[4] || (_cache[4] = _createTextVNode(" Track ", -1))
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs text-blue-700 dark:text-blue-300 mt-1 font-medium" }, " Progress & Work ", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[1]?.children, (child) => {
                    return (_openBlock(), _createBlock(_component_ULink, {
                      key: child.label,
                      to: child.to,
                      class: "flex items-start gap-3 p-2 rounded-md hover:bg-blue-100 dark:hover:bg-blue-900/30 transition-colors group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UIcon, {
                          name: child.icon,
                          class: "h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 shrink-0"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("p", _hoisted_16, _toDisplayString(child.label), 1),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(child.description), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_UIcon, {
                      name: "i-heroicons-squares-2x2",
                      class: "h-3 w-3"
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Centralise ", -1))
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs text-purple-700 dark:text-purple-300 mt-1 font-medium" }, " Operations ", -1))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discoverGroups)[2]?.children, (child) => {
                    return (_openBlock(), _createBlock(_component_ULink, {
                      key: child.label,
                      to: child.to,
                      class: "flex items-start gap-3 p-2 rounded-md hover:bg-purple-100 dark:hover:bg-purple-900/30 transition-colors group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UIcon, {
                          name: child.icon,
                          class: "h-4 w-4 text-purple-600 dark:text-purple-400 mt-0.5 shrink-0"
                        }, null, 8, ["name"]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(child.label), 1),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(child.description), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }, 8, ["ui"]))
}
}

})